<template lang="pug">
  .b2b-table-cmr-emit
    //- Filtro Tabla cmr
    b2b-filters-cmr-emit(
      :filter-options='options')

    //- Tabla de cmr
    ods-table(
      :data='cmrEmit.tableData',
      :start-sort='{ prop: "creationDateTime", order: "descending"}',
      style='width: 100%',
      @sort-change="orderOnServer",
      @cell-mouse-enter='handleCellMouseEnter',
      @selection-change='handleSelectionChange',
      highlight-current-row,
      size='small',
      fit)
      ods-table-column(
        type='selection',
        width='55')
      //- 1 Empresa carga
      ods-table-column(
        prop='partySenderName',
        :label='$t("cmr.cmr_entity_table_detail.loadparty")',
        :show-overflow-tooltip='true',
        v-if='isShowSenderPartyCmrEmit',
        sortable='')
      //- 2 Centro carga o lugar de origen
      ods-table-column(
        prop='centreSenderTooltip',
        :label='$t("cmr.cmr_entity_table_detail.seller_centre")',
        :show-overflow-tooltip='true',
        v-if='isShowSenderCentreCmrEmit',
        sortable='')
      //- 3 Empresa entrega
      ods-table-column(
        prop='partyReceiverName',
        :label='$t("cmr.cmr_entity_table_detail.deliveryparty")',
        :show-overflow-tooltip='true',
        v-if='isShowReceiverPartyCmrEmit',
        sortable='')
      //- 4 Centro entrega o lugar de destino
      ods-table-column(
        prop='centreReceiverTooltip',
        :label='$t("cmr.cmr_entity_table_detail.buyer_centre")',
        :show-overflow-tooltip='true',
        v-if='isShowReceiverCentreCmrEmit',
        sortable='')
      //- 5 Número de carta de porte
      ods-table-column(
        prop='cmrNumber',
        :label='$t("cmr.cmr_entity_table_detail.cmrNumber")',
        :show-overflow-tooltip='true',
        v-if='isShowNumberCmrEmit',
        sortable='')
      //- 6 F. envío
      ods-table-column(
        prop='sendDate',
        :label='$t("cmr.cmr_entity_table_detail.send_date")',
        align='center',
        :show-overflow-tooltip='true',
        v-if='isShowSendDateCmrEmit',
        :formatter='formatterDate',
        sortable='')
      //- 7 F. registro
      ods-table-column(
        prop='creationDateTime',
        :label='$t("cmr.cmr_entity_table_detail.dateCreation")',
        align='center',
        :show-overflow-tooltip='true',
        v-if='isShowCreationDateTimeCmrEmit',
        :formatter='formatterDate',
        sortable='')
      //- 8 Estado
      ods-table-column(
        prop='statusdesc',
        :label='$t("cmr.cmr_entity_table_detail.status")',
        v-if='isShowStatusCmrEmit',
        sortable='')
        template(slot-scope='scope')
          ods-tooltip(placement='top')
            template(slot='content')
              | {{ formatterTooltipCmrStatus(scope.row, scope.column) }}
            div.text-overflow-tooltip
              | {{ formatterCmrStatus(scope.row, scope.column) }}
      //- 9 Servicio
      ods-table-column(
        prop='project.name',
        :label='$t("cmr.cmr_entity_table_detail.service")',
        :show-overflow-tooltip='true',
        v-if='isShowServiceCmrEmit',
        sortable='')
      //- 10 Empresa transportista
      ods-table-column(
        prop='nameTransportist',
        :label='$t("cmr.cmr_entity_table_detail.transportist_default")',
        :show-overflow-tooltip='true',
        v-if='isShowTransportistCmrEmit',
        sortable='')
      //- 11 Matrícula
      ods-table-column(
        prop='vehiclePlate',
        :label='$t("cmr.cmr_entity_table_detail.plate")',
        :show-overflow-tooltip='true',
        v-if='isShowVehiclePlateCmrEmit',
        sortable='')
      //- 12 Matrícula trailer
      ods-table-column(
        prop='trailerPlate',
        :label='$t("cmr.cmr_entity_table_detail.trailerplate")',
        :show-overflow-tooltip='true',
        v-if='isShowTrailerPlateCmrEmit',
        sortable='')
      //- Ocultas por defecto
      //- 13 Pedido
      ods-table-column(
        prop='order',
        :label='$t("cmr.cmr_entity_table_detail.order")',
        :show-overflow-tooltip='true',
        v-if='isShowOrderCmrEmit',
        sortable='')
      //- 14 Agrupación
      ods-table-column(
        prop='group',
        :label='$t("cmr.cmr_entity_table_detail.group")',
        :show-overflow-tooltip='true',
        v-if='isShowGroupCmrEmit',
        sortable='')
      ods-table-column(
        label,
        :render-header='renderHeaderActions',
        width='100')
        template(slot-scope='scope' placement='center')
          ods-tooltip(placement='left')
            template(slot='content')
              | {{ $t('invoices.tooltip.detail') }}
            ods-button(
              style=' padding-left: 0px; padding-right: 0px;'
              type='neutral',
              icon-position='left'
              @click='handleGoDetail(scope.row)')
              ods-icon(name='search', size='16')
          ods-tooltip(placement='left')
            template(slot='content')
              | {{ $t('cmr.cmr_entity_table_detail.download_pdf') }}
            ods-button(
              v-if="scope.row.pdfPath != null",
              style=' padding-left: 0px; padding-right: 0px;'
              type='neutral',
              @click="handleDownloadCmrPdf(scope.row)")
              ods-icon(name='download', size='16')
    //- Paginación Tabla
    ods-row.b2b-table-cmr-emit__pagination(v-if='cmrEmit')
      ods-col.b2b-table-cmr-emit__pagination--left(:span='4')
        ods-tooltip(:content='$t("invoices.buttons.download_csv_tooltip")', placement='bottom')
          ods-button(
            type='primary',
            size='mini',
            round='',
            icon='ods-icon-download'
            style='display:inline;'
            @click='handleDownloadAllCsvEmitted')
            | CSV
      ods-col.b2b-table-cmr-emit__pagination--right(:span='20')
        div.block(style='margin-bottom: 50px;')
          ods-pagination(
            ref='pagination',
            popper-class='b2b-pagination__dropdown',
            @size-change='handleSizeChange',
            @current-change='handleCurrentChangePagination',
            :current-page.sync='currentPage',
            :page-sizes='[20, 50, 100]',
            :page-size='20',
            layout='total, sizes, prev, pager, next, slot',
            :total='cmrEmit.totalCmrsEmit')

    //- cmr Emitidos Seleccionadas
    transition(
      name='slide',
      mode='out-in')
      b2b-table-select-rows(
        v-if='multipleSelection.length',
        :total-select='multipleSelection.length')
        div(slot='actions')
          ods-tooltip(:content='$t("invoices.buttons.download_invoices_tooltip")', placement='bottom')
            ods-button(
              v-if="multipleSelectionHasPdf",
              icon='ods-icon-download',
              size='small',
              circle,
              @click.native='handleDownloadMultiplePdf')
              | {{ $t('invoices.buttons.download_invoices') }}
</template>

<script>
import { mapGetters, mapActions } from 'vuex'
import router from '@/router/index'
import B2bFiltersCmrEmit from '@/views/cmr/emitidos/B2bFiltersCmrEmit'
import B2bTableMenuCmrEmit from '@/views/cmr/emitidos/B2bTableMenuCmrEmit'
import B2bTableSelectRows from '@/components/B2bTableSelectRows'
import filters from './filtros-cmr-emit'
import moment from 'moment'
import Utils from '@/components/shared/Utils'

export default {
  name: 'b2b-table-cmr-emit',
  mixins: [Utils],
  data () {
    return {
      // Tabla
      currentRow: {},
      multipleSelection: [],
      multipleSelectionIds: [],
      // Paginación
      currentPage: null

    }
  },

  computed: {
    ...mapGetters([
      'cmrEmit',
      'queryCmrEmit',
      'isShowNumberCmrEmit',
      'isShowOrderCmrEmit',
      'isShowGroupCmrEmit',
      'isShowVehiclePlateCmrEmit',
      'isShowTrailerPlateCmrEmit',
      'isShowSenderPartyCmrEmit',
      'isShowSenderCentreCmrEmit',
      'isShowReceiverPartyCmrEmit',
      'isShowReceiverCentreCmrEmit',
      'isShowCreationDateTimeCmrEmit',
      'isShowStatusCmrEmit',
      'isShowServiceCmrEmit',
      'isShowSendDateCmrEmit',
      'isShowTransportistCmrEmit',
      'urlIn',
      'getActiveLang'
    ]),

    multipleSelectionHasPdf () {
      return this.multipleSelection.some(item => item.pdfPath != null)
    }
  },

  components: {
    B2bFiltersCmrEmit,
    B2bTableMenuCmrEmit,
    B2bTableSelectRows
  },

  methods: {
    ...mapActions([
      'getOptionsService',
      'getCmrNotes',
      'queryCmrEmitState',
      'downloadCmrCsv',
      'downloadCmrPdfMultiple',
      'downloadCmrPdf',
      'downloadCmrOriginal',
      'optionsFilterServiceState'
    ]),

    // Ordenar Tabla
    async orderOnServer ({ column, order, prop }) {
      let stringSort = ''
      const load = this.$loading({
        lock: true,
        text: this.$t('msg_generics.order_table')
      })

      if (order === 'descending') {
        order = 'DESC'
      } else if (order === 'ascending') {
        order = 'ASC'
      } else {
        order = 'ASC'
      }
      if (!prop) {
        prop = 'creationDateTime'
      } else {
        switch (prop) {
          case 'order':
            prop = 'orderCmr'
            break
          case 'partySenderName':
            prop = 'partyByIdSender.tradeName'
            break
          case 'centreSenderTooltip':
            prop = 'centreSender.description'
            break
          case 'partyReceiverName':
            prop = 'partyByIdReceiver.tradeName'
            break
          case 'centreReceiverTooltip':
            prop = 'centreReceiver.description'
            break
          case 'group':
            prop = 'groupCmr'
            break
          case 'statusdesc':
            prop = 'statusDocument.status'
            break
        }
      }

      stringSort = prop + ',' + order
      this.queryCmrEmit.sort = stringSort

      try {
        if (this.urlIn && this.urlIn !== 'b2b') {
          this.queryCmrEmit.urlName = this.urlIn
        } else {
          this.queryCmrEmit.urlName = null
        }
        await this.queryCmrEmitState(this.queryCmrEmit)
      } catch (error) {
        console.log('orderOnServer CATCH: ', error)
        this.getNotificationErrorMessage(error)
      } finally {
        load.close()
      }
    },

    // Descargar todos a CSV
    async handleDownloadAllCsvEmitted () {
      if (this.cmrEmit.totalCmrsEmit > 120000) {
        this.$notify({
          title: this.$t('cmr.cmr_entity_table_detail.csv_title'),
          message: this.$t('cmr.cmr_entity_table_detail.csv_message', { argumento: '120.000' }),
          type: 'Warning',
          iconClass: 'ods-icon-warning',
          position: 'top-right',
          customClass: 'b2b-notification-info',
          duration: 10000
        })
      } else {
        const load = this.$loading({
          lock: true,
          text: this.$t('msg_generics.download_csv')
        })
        const params = this.queryCmrEmit

        try {
          params.activeLang = this.getActiveLang
          const filename = await this.downloadCmrCsv(params)
          this.$notify({
            title: this.$t('msg_generics.download_file_ok', { filename: filename }),
            type: 'success',
            position: 'top-right',
            customClass: 'b2b-notification-success',
            duration: 10000
          })
        } catch (error) {
          console.log('handleDownloadAllCsvEmitted CATCH: ', error)
          this.getNotificationErrorMessage(error)
        } finally {
          load.close()
        }
      }
    },

    // Conseguir datos de la fila en el hover del ratón
    handleCellMouseEnter (row, column, cell, event) {
      this.currentRow = row
    },

    // Selección de Filas con el checkbox
    handleSelectionChange (val) {
      this.multipleSelection = val
      if (val.length === 0) {
        this.multipleSelection = []
      }
      this.multipleSelectionIds = this.multipleSelection.map(item => item.id)
    },

    // Ir al detalle
    handleGoDetail (invoice) {
      sessionStorage.setItem('cmrNumber', this.currentRow.cmrNumber)
      router.push({
        name: 'cmr-detail',
        params: {
          cmrId: this.currentRow.id,
          cmrNumber: this.currentRow.cmrNumber
        }
      })
    },

    formatterTooltipCmrStatus (row, column) {
      if (row.messageStatus && row.messageStatus !== '') return this.formatterCmrStatus(row, column) + ' - ' + row.messageStatus
      else return this.formatterCmrStatus(row, column)
    },

    // Formatear estado de cmr
    formatterCmrStatus (row, column) {
      return this.$t('cmr_status.' + row[column.property])
    },

    // Formatear fechas Tabla
    formatterDate (row, column) {
      if (row[column.property]) {
        const date = moment(row[column.property])
        if (column.property === 'creationDateTime' || column.property === 'deliveryDate') {
          return date.format(this.$t('date_format_long'))
        } else {
          return date.format(this.$t('date_format'))
        }
      }
    },

    // JSX Menu Tabla
    renderHeaderActions: h => {
      return <B2bTableMenuCmrEmit />
    },

    // Tamaño Tabla (20,50,100)
    async handleSizeChange (val) {
      const load = this.$loading({
        lock: true,
        text: this.$t('msg_generics.size_table')
      })
      try {
        const dataQuery = { query: {} }
        this.queryCmrEmit.size = val
        if (this.urlIn && this.urlIn !== 'b2b') {
          this.queryCmrEmit.urlName = this.urlIn
        } else {
          this.queryCmrEmit.urlName = null
        }
        await this.queryCmrEmitState(this.queryCmrEmit)
        dataQuery.query = this.queryCmrEmit
        await this.getCmrNotes(dataQuery)
      } catch (error) {
        console.log('handleSizeChange CATCH: ', error)
        this.getNotificationErrorMessage(error)
      } finally {
        load.close()
      }
    },

    // Paginacion
    async handleCurrentChangePagination (val) {
      const load = this.$loading({
        lock: true,
        text: this.$t('msg_generics.pagination_table')
      })

      try {
        const dataQuery = { query: {} }
        this.queryCmrEmit.page = val - 1
        if (this.urlIn && this.urlIn !== 'b2b') {
          this.queryCmrEmit.urlName = this.urlIn
        } else {
          this.queryCmrEmit.urlName = null
        }
        await this.queryCmrEmitState(this.queryCmrEmit)
        dataQuery.query = this.queryCmrEmit
        const results = await this.getCmrNotes(dataQuery)
        console.log('CMRs:::: ', results)
      } catch (error) {
        console.log('handleCurrentChangePagination CATCH: ', error)
        this.getNotificationErrorMessage(error)
      } finally {
        load.close()
      }
    },
    // Descarga de pdf
    async handleDownloadCmrPdf () {
      const load = this.$loading({
        lock: true,
        text: this.$t('msg_generics.download_pdf')
      })
      try {
        const params = {
          cmrIds: [this.currentRow.id],
          searchType: 'EMITTED'
        }
        const filename = await this.downloadCmrPdfMultiple(params)
        this.$notify({
          title: this.$t('order.order_detail.notify.download_pdf', { file: filename }),
          type: 'success',
          position: 'top-right',
          customClass: 'b2b-notification-success',
          duration: 10000
        })
      } catch (error) {
        this.getNotificationErrorMessage(error)
      } finally {
        load.close()
      }
    },

    // Seleccionadas
    async handleDownloadMultiplePdf () {
      const cmrIds = this.multipleSelectionIds.filter((item, index, self) => {
        return index === self.indexOf(item)
      })
      const load = this.$loading({
        lock: true,
        text: this.$t('invoices.loading.download_invoices')
      })
      console.log('handleDownloadPdf() VALUES ->', cmrIds)
      try {
        const params = {
          cmrIds: cmrIds,
          searchType: 'EMITTED'
        }
        const filename = await this.downloadCmrPdfMultiple(params)
        this.$notify({
          title: this.$t('msg_generics.download_file_ok', { filename: filename }),
          type: 'success',
          position: 'top-right',
          customClass: 'b2b-notification-success',
          duration: 10000
        })
      } catch (error) {
        console.log('handleDownloadPdf CATCH: ', error)
        this.getNotificationErrorMessage(error)
      } finally {
        load.close()
      }
    },

    async getNotificationErrorMessage (error) {
      let errorSms = ''
      let statusCode = null

      statusCode = error ? error.status : 0
      switch (statusCode) {
        case 400:
          errorSms = error.data.message
          break
        case 401:
          errorSms = this.$i18n.messages.es.error.e401

          break
        case 403:
          errorSms = this.$i18n.messages.es.error.e403
          break
        case 404:
        case 500:
          errorSms = error.data.message
          if (errorSms === undefined && error.config.responseType === 'blob') {
            errorSms = this.$t('msg_generics.error_download_not_found')
          }
          break
        case 409:
          errorSms = error.data.message
          break
        default:
          errorSms = this.$i18n.messages.es.error.default
          break
      }
      error.data.message = errorSms
      this.showNotificationError(error)
    }
  },

  async created () {
    const load = this.$loading({
      lock: true,
      text: this.$t('msg_generics.load_init')
    })
    try {
      const dataQuery = { query: {} }
      this.options = filters.filters

      const dataQueryProj = { page: 0, size: 1000, sort: 'name,ASC', isSender: true }
      const optionsFilterService = await this.getOptionsService(dataQueryProj)
      await this.optionsFilterServiceState(optionsFilterService)

      if (optionsFilterService.length === 1) {
        this.queryCmrEmit.projectId = optionsFilterService[0].id
      }
      this.currentPage = this.queryCmrEmit.page + 1
      if (this.urlIn && this.urlIn !== 'b2b') {
        this.queryCmrEmit.urlName = this.urlIn
      } else {
        this.queryCmrEmit.urlName = null
      }
      dataQuery.query = this.queryCmrEmit
      const response = await this.getCmrNotes(dataQuery)
      console.log('response', response)
    } catch (error) {
      console.log('getCmrNotes CATCH: ', error)
      this.getNotificationErrorMessage(error)
    } finally {
      load.close()
    }
  }
}
</script>

<style lang="scss" scoped>
.b2b-table-cmr-emit {
  ::v-deep .ods-table {
    th {
      padding: rem(0);
      padding-top: rem(4);

      .cell {
        font-weight: 500;
      }
      .ods-dropdown{
        padding-left: 0px;
        padding-right: 0px;
      }

      &:last-child {
        padding-top: rem(0);
        .cell {
          .ods-dropdown {
            line-height: 32px;
          }
        }
      }
      .cell:last-child {
        .ods-dropdown {
          line-height: 32px;
        }
      }
    }
    &__row {
      .cell {
        .text-overflow-tooltip {
          white-space: nowrap;
          overflow: hidden;
          text-overflow: ellipsis;
        }
      }
      .ods-button {
        padding: rem(1) rem(15) rem(0) rem(15);
        margin-left: rem(0);
        margin-right: rem(0);
        i {
          margin-left: rem(0);
        }
      }
    }
  }

  ::v-deep &__pagination {
    margin: rem(32) rem(24) rem(32) rem(24);
    &--left {
      .ods-button {
        font-size: 0.625rem;
        line-height: 1.4;
        letter-spacing: .04rem;
        text-align: center;
        i {
          &:before {
            font-size: 0.625rem;
          }
        }
      }
    }
    &--right {
      .ods-pagination {
        justify-content: flex-end;
        width: auto;
        padding-top: rem(0);
        float: right;
        &__label {
          padding-top: rem(0);
          float: right
        }
      }
    }
  }
}
</style>
